export default {"src":"/_next/static/media/bfm.dffda39f.svg","height":106,"width":321};